import * as types from 'actions/actionTypes'

import initialState from './initialState'

export const documentType = (state = initialState.documentTypes, action) => {
  switch (action.type) {
    case types.FETCH_DOCUMENT_TYPES_SUCCESS:
      return { ...state, documentTypes: action.payload, loader: false }

    case types.FETCH_DOCUMENT_TYPES_FAILURE:
      return { ...state, loader: false }

    case types.CREATE_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        documentTypes: [...state.documentTypes, action.payload],
        loader: false
      }

    case types.CREATE_DOCUMENT_TYPE_FAILURE:
      return { ...state, loader: false }

    case types.UPDATE_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        documentTypes: state.documentTypes.map((docType) =>
          docType.id === action.payload.id ? action.payload : docType
        ),
        loader: false
      }

    case types.UPDATE_DOCUMENT_TYPE_FAILURE:
      return { ...state, loader: false }

    case types.DELETE_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        documentTypes: state.documentTypes.filter((docType) => docType.id !== action.payload.id),
        loader: false
      }

    case types.DELETE_DOCUMENT_TYPE_FAILURE:
      return { ...state, loader: false }

    default:
      return state
  }
}
